module.exports = __webpack_public_path__ + "img/symbol_2.36bebd35.png";